import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { MsalGuard } from "@azure/msal-angular";

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
    constructor(private msalGuard: MsalGuard) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        sessionStorage.setItem("postLoginRedirectUrl", state.url);
        return this.msalGuard.canActivate(route, state);
    }
}
